import React from 'react';
import { Skeleton } from 'antd';

const SkeletonLoader = () => (
  <Skeleton active />
);

export default SkeletonLoader;
